<div class="card-container" #container>
    <!-- Cabeçalho do cartão -->
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('reservas') }} </h3>
        <span></span>
    </div>

    <div class="card-component">
        <!-- Configuração da grelha Kendo -->
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="50"
            [pageable]="true" [sortable]="true" [groupable]="true" [filterable]="true" [reorderable]="true"
            [resizable]="true" [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            
            <!-- Barra de ferramentas da grelha -->
            <ng-template kendoGridToolbarTemplate>
                <!-- Caixa de texto para pesquisa -->
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>

                <!-- Formulário para filtro por data -->
                <form class="k-form k-form-horizontal"
                    style="max-width: 200px;width: 200px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataDe" [text]="customMsgService.translate('de')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataDe" #dataDe></kendo-datepicker>
                    </kendo-formfield>
                </form>

                <form class="k-form k-form-horizontal"
                    style="max-width: 350px;width: 350px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataAte" [text]="customMsgService.translate('ate')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataAte" #dataAte></kendo-datepicker>
                    </kendo-formfield>
                    <button kendoButton (click)="pesquisar()" themeColor="primary">
                        {{customMsgService.translate('filtrarEntreDatas')}} </button>
                </form>

                <!-- Espaçador da grelha -->
                <kendo-grid-spacer></kendo-grid-spacer>
                <!-- Botões para exportar Excel e PDF -->
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

            <!-- Colunas da grelha -->
            <kendo-grid-column field="dataCriacao" [title]="customMsgService.translate('movDataHoracriacao')" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.dataCriacao | date:"YYYY-MM-dd HH:mm:ss" }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="reservaUID" [title]="'ID'" [width]="70">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{dataItem.reservaUID}}">
                        <div class="customer-name"> {{ dataItem.reservaUID | slice:0:19 }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="descricaoEstado" [title]="customMsgService.translate('estado')" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('datahoraAtualizacao')}}: {{dataItem.dataAtualizacao | date:'yyyy-MM-dd HH:mm:ss'}}">    
                        <div class="customer-name"> {{ dataItem.descricaoEstado }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="pagaAte" [title]="customMsgService.translate('pagaAte')" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.pagaAte | date:"yyyy-MM-dd HH:mm:ss"}} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="horasExtra" [title]="customMsgService.translate('horasExtraAPagar')" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.horasExtra }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')" [width]="40">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nomeArmario }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('cacifo')" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('dataHoraUltimaAbertura')}}: {{dataItem.ultimaAbertura | date:'yyyy-MM-dd HH:mm:ss'}}">
                        <div class="customer-name"> {{ dataItem.nomeCompartimento }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Tokens" [title]="customMsgService.translate('token')" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="lock" [title]="customMsgService.translate('btnEditar')"
                        (click)="openTokenFrom(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Pagamentos" [title]="customMsgService.translate('pagamentos')" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="dollar" [title]="customMsgService.translate('btnEditar')"
                        (click)="openPaymentForm(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- Configuração para exportação em PDF -->
            <kendo-grid-pdf fileName="{{customMsgService.translate('reservas')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('reservas') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="dataCriacao" filter="date"
                    [title]="customMsgService.translate('movDataHoracriacao')">
                </kendo-grid-column>

                <kendo-grid-column field="reservaUID" [title]="'ID'">
                </kendo-grid-column>

                <kendo-grid-column field="descricaoEstado" [title]="customMsgService.translate('estado')">
                </kendo-grid-column>

                <kendo-grid-column field="pagaAte" [title]="customMsgService.translate('pagaAte')">
                </kendo-grid-column>

                <kendo-grid-column field="validaAte" [title]="customMsgService.translate('validoAte')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeArmario" [title]="customMsgService.translate('armario')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeCompartimento" [title]="customMsgService.translate('cacifo')">
                </kendo-grid-column>
            </kendo-grid-pdf>

            <!-- Configuração para exportação em Excel -->
            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('reservas')}}.xlsx">
            </kendo-grid-excel>
        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>
